import { useId, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Container from "../container";
import Button from "../UI/button";
import TextBlock from "../textBlock";
import c from "./styles.module.scss";

const STORAGE_KEY = "cookieConsent";

const CookiePopup = () => {
  const { pathname } = useLocation();
  const titleId = useId();
  const [accepted, setAccepted] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "accepted";
    } catch {
      return false;
    }
  });
  const [dismissed, setDismissed] = useState(false);
  const show = !accepted && !dismissed && pathname !== "/privacyPolicy";

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "accepted");
    } catch {
      // Keep the site usable when browser storage is unavailable.
    }
    setAccepted(true);
  };

  if (!show) return null;

  return (
    <section className={c.banner} aria-labelledby={titleId}>
      <Container>
        <div className={c.content}>
          <TextBlock>
            <h2 id={titleId}>Использование cookie</h2>
            <p>
              Мы используем файлы cookie для работы сайта и анализа его посещаемости.
              Подробнее — в{" "}
              <Link to="/privacyPolicy">политике конфиденциальности</Link>.
            </p>
          </TextBlock>
          <div className={c.actions}>
            <Button text="Принять" full onClick={accept} />
            <Button
              text="Закрыть"
              btnStyle="outline"
              full
              onClick={() => setDismissed(true)}
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CookiePopup;
